import { BALI_API_BASE_URL } from "../constants";
import AuthTokenManager from "../components/Auth/AuthTokenManager";

export class APIError extends Error {
  constructor(
    message: string,
    public status: number,
    public response: Response
  ) {
    super(message);
    this.name = "APIError";
  }
}

type RequestOptions = Omit<RequestInit, "method" | "body">;

const createUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  return `${BALI_API_BASE_URL}/${cleanEndpoint}`;
};

const makeRequest = async <T>(
  endpoint: string,
  method: string,
  options?: RequestOptions
): Promise<T> => {
  const token = AuthTokenManager.getInstance().getToken();
  const headers = new Headers(options?.headers);

  if (token) headers.set("Authorization", `Bearer ${token}`);

  const response = await fetch(createUrl(endpoint), {
    ...options,
    method,
    headers,
  });

  if (response.ok) return response.json();

  throw new APIError(
    `API request failed: ${response.statusText}`,
    response.status,
    response
  );
};

export const baliApiClient = {
  get: <T>(endpoint: string, options?: RequestOptions): Promise<T> =>
    makeRequest<T>(endpoint, "GET", options),
};
